export default __webpack_public_path__ + "static/media/hash-small.e92fee61.svg";